module.exports = __webpack_public_path__ + "static/media/rrpspPoster.a9f165ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/rrpspPoster.jpg
// module id = 477
// module chunks = 0